<wa-card class="card-header">
  <div slot="header" class="wa-heading-s">Export</div>
  <div class="wa-stack wa-gap-m">
    @if (optimizationFailed()) {
      <wa-callout variant="danger">
        <wa-icon slot="icon" name="triangle-exclamation" variant="regular"></wa-icon>
        <strong>Optimization for this survey has failed.</strong><br/>
        Please check the optimization logs to find the root cause of the problem and try again.
      </wa-callout>
    }

    <div class="wa-cluster export-actions">
      <wa-button variant="brand" appearance="filled" (click)="getPreferencesExport()">
        <wa-icon slot="prefix" name="download"></wa-icon>
        export preferences
      </wa-button>

      <wa-button variant="neutral" appearance="filled" (click)="getCsv()" [disabled]="!canExportAssignments()">
        <wa-icon slot="prefix" name="download"></wa-icon>
        export allocation
      </wa-button>

      <wa-button variant="neutral" appearance="filled" (click)="getAllocExport_2_0()" [disabled]="!canExportAssignments()">
        <wa-icon slot="prefix" name="download"></wa-icon>
        export allocation 2.0
      </wa-button>
    </div>
  </div>
</wa-card>

